import request from '@/utils/request'

export function getpublicityist(data) {
  return request.post('/publicity/list', data)
}

export function deletepub(data) {
  return request.post('/publicity/delete', data)
}

export function add(data) {
  return request.post('/publicity/add', data)
}
export function uploadx(data) {
  return request.post('/publicity/upload', data)
}
export function modify(data) {
  return request.post('/publicity/modify', data)
}
export function deleteFileX(data) {
  return request.post('/publicity/delete-file', data)
}
export function getfilelist(data){
  return request.post('/file/publicity-list',data)
}



// WEBPACK FOOTER //
// ./src/api/publicity.js